import { render, staticRenderFns } from "./dropdown-category.vue?vue&type=template&id=1cc627ef&scoped=true"
import script from "./dropdown-category.vue?vue&type=script&lang=js"
export * from "./dropdown-category.vue?vue&type=script&lang=js"
import style0 from "./dropdown-category.vue?vue&type=style&index=0&id=1cc627ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc627ef",
  null
  
)

export default component.exports